import { teamMemberService } from "../../../../../Api/Services/TeamMembers";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";
import { ITeamMemberServiceResponse } from "../../types";

/**
 * Async thunk to fetch team members list.
 * Dispatches an API call to retrieve the team members data.
 */
export const fetchTeamMembersAsyncThunk = createServiceAsyncThunk<
  ITeamMemberServiceResponse, // Response Type
  void // Payload Type
>(
  ACTION_NAMES.FETCH_TEAM_MEMBERS, // Action Name
  () => teamMemberService.getTeamMembers(), // API Call
  ERROR_MESSAGES.TEAM_MEMBERS_LIST_FETCH_FAILURE // Error Message
);

/**
 * Slice to manage the state of team members list.
 * Includes actions to clear errors and handle async states.
 */
const teamMembersListSlice = createGenericSlice<
  ITeamMemberServiceResponse,
  void
>(SLICE_NAMES.TEAM_MEMBERS, fetchTeamMembersAsyncThunk);

// Export the action to reset the error state
export const {
  clearError: clearTeamMembersListError,
  clearSuccessMessage: clearTeamMembersListSuccess,
} = teamMembersListSlice.actions;

// Export the reducer to be used in the store
export default teamMembersListSlice.reducer;
